import {makeAutoObservable} from 'mobx';
import s from '../../s';

// A lino's desc1 lists the programs (states) it belongs to: "Arkansas,Oklahoma,Texas".
const programsOf = (desc1: string): string[] => desc1.split(',').map(item => item.trim());

/**
 * Store 205164's add-to-cart check: the shopper picked a council, i.e. one of the product's non-base linos. The base lino is the
 * "your council name here" placeholder, which the page falls back to when the program is cleared (WEB issue 239).
 */
export const isCouncilChosen = (linos: {id: number; isBase: boolean}[], linoId: number): boolean => linos.some(lino => !lino.isBase && lino.id === linoId);

class LinoStore {
    public selectedDesc1: string = '';

    constructor() {
        makeAutoObservable(this);
    }

    // Computed, so Lino can read it while rendering: an action that stored it from render wrote the observable that render reads,
    // and every render scheduled another one (WEB issue 232).
    get desc1Options(): string[] {
        const options = s.linoChoices.options
            .filter(i => !i.isBase)
            .flatMap(i => programsOf(i.desc1))
            .sort();

        return [...new Set(options)];
    }

    setSelected(desc1: string) {
        this.selectedDesc1 = desc1;
    }

    // Whole program names: a substring match put Arkansas's council first under Kansas, and West Virginia's under Virginia.
    get desc2OptionsFiltered() {
        const selected = this.selectedDesc1.toLowerCase();
        return selected
            ? s.linoChoices.options.filter(i => programsOf(i.desc1).some(program => program.toLowerCase() === selected)).sort((a, b) => a.desc2.localeCompare(b.desc2))
            : [];
    }
}

export const linoStore = new LinoStore();
